import pageStyles from 'assets/styles/components/Page.styles';
import Container from 'components/Container/Container';
import Loader from 'components/Loader/Loader';
import Redirecting from 'components/Redirecting/Redirecting';
import { useSessionContext } from 'context/SessionProvider/SessionProvider';
import { History } from 'history';
import {
  ChannelLegacy,
  PermissionName,
  useAllChannelsLegacyQuery,
} from 'interfaces/generated.types';
import React from 'react';
import { userHasAtLeastOnePermission } from 'utils/permissions';

import ChannelsTable from '../../components/ChannelsTable/ChannelsTable';

interface IChannelsPageProps {
  history: History;
  userPermissions: PermissionName[];
}

const channelEditPermissions = [PermissionName.Primary, PermissionName.Supply];

const ChannelsPage = ({ history, userPermissions }: IChannelsPageProps) => {
  const {
    state: {
      user: { activeTerritory },
    },
  } = useSessionContext();
  const { loading, data, error } = useAllChannelsLegacyQuery({
    errorPolicy: 'all',
    variables: { territories: [activeTerritory!] },
  });

  if (!loading && error && !(data && data.allChannelsLegacy))
    return <Redirecting history={history} />;

  const classes = pageStyles();

  const hasEditPermissions = userHasAtLeastOnePermission(
    userPermissions,
    channelEditPermissions
  );

  return (
    <main className={classes.page}>
      <Container>
        <h1 className="sr-only">Channels</h1>
        <div className={classes.table}>
          {loading ? (
            <Loader />
          ) : (
            <ChannelsTable
              history={history}
              channels={(data?.allChannelsLegacy as ChannelLegacy[]) || []}
              isEditable={hasEditPermissions}
              title="All Channels"
              activeTerritory={activeTerritory!}
            />
          )}
        </div>
      </Container>
    </main>
  );
};

export default ChannelsPage;
